"use strict";const t=require("./index-114fb5a2.js"),r=require("./index-8b6fbbdb.js");function i(e){return r.requiredArgs(1,arguments),t.toDate(e).getTime()<Date.now()}exports.isPast=i;
